

























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Alert from '@/components/Shared/Alert.vue';
import JobBrowseWorkers from '@/components/JobWorkers/JobBrowseWorkers.vue';
import JobInterestedWorkers from '@/components/JobWorkers/JobInterestedWorkers.vue';
import JobShortlistedWorkers from '@/components/JobWorkers/JobShortlistedWorkers.vue';
import JobInterviewingWorkers from '@/components/JobWorkers/JobInterviewingWorkers.vue';
import JobRejectedWorkers from '@/components/JobWorkers/JobRejectedWorkers.vue';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import GiganautVue from '@/components/Shared/GiganautVue';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import PrepareForLaunch from '@/components/Shared/PrepareForLaunch.vue';
import JobOfferWorkers from '@/components/JobWorkers/JobOfferWorkers.vue';
import JobPlacedWorkers from '@/components/JobWorkers/JobPlacedWorkers.vue';

@Component({
  name: 'JobWorkers',
  components: { Alert, PrepareForLaunch, JobBrowseWorkers,JobShortlistedWorkers, JobInterestedWorkers, JobInterviewingWorkers, JobOfferWorkers, JobRejectedWorkers, JobPlacedWorkers }}
  )
export default class extends GiganautVue {

    jobWorkerStatus = JobWorkerStatus;
    async beforeMount() {
		await JobDetailsModule.getWorkerSearchOptions();
		await JobDetailsModule.getJobWorkers();
		await JobDetailsModule.browseDefaultWorkerSearch()
        if (this.shortlistedWorkers.length > 0) {
            this.tab = 1;
        }
        if (this.interestedWorkers.length > 0) {
            this.tab = 2;
        }
        if (this.interviewingWorkers.length > 0) {
            this.tab = 3;
        }
        if (this.offerWorkers.length > 0) {
            this.tab = 4;
        }
        if (this.placedWorkers.length > 0) {
            this.tab = 5;
        }
	}

    get loading() {
        return JobDetailsModule.loadingWorkers;
    }

	get currentJob() {
		return JobDetailsModule.currentJob;
    }

    get tab() {
        return JobDetailsModule.jobWorkersVM.currentTabIndex;
    }

    set tab(tabIndex: number) {
        JobDetailsModule.jobWorkersVM.currentTabIndex = tabIndex;
    }

    get jobWorkers() {
        return JobDetailsModule.jobWorkersVM.jobWorkers;
    }

    get shortlistedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatus.SentToWorker || 
			jobWorker.status === JobWorkerStatus.Shortlisted
			))
	}

    get interestedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatus.WorkerInterested ||
            jobWorker.status === JobWorkerStatus.ContactInterested ||
            jobWorker.status === JobWorkerStatus.SentToContact
			))
	}

    get interviewingWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatus.InterviewOne ||
            jobWorker.status === JobWorkerStatus.InterviewTwo
			))
	}
 
    get offerWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatus.Offer
			))
	}

    get placedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
			jobWorker.status === JobWorkerStatus.Placed
			))
	}

    get rejectedWorkers() {
		return this.jobWorkers.filter((jobWorker) => (
            jobWorker.status === JobWorkerStatus.WorkerNotInterested ||
			jobWorker.status === JobWorkerStatus.ContactNotInterested ||
            jobWorker.status === JobWorkerStatus.Rejected
			))
	}

        get isLoading() {
        return JobDetailsModule.loadingWorkers;
    }
}
